import { useState, useEffect, useRef } from 'react';
import { useTextToSpeech } from './useTextToSpeech';
import { useVoiceCapability } from './useVoiceCapability';
import { useSpeechRecognition } from './useSpeechRecognition';
import { useAuth } from '@/contexts/AuthContext';

export function useVoiceInteraction() {
  const [shouldAutoSpeak, setShouldAutoSpeak] = useState(false);
  const [voiceInputUsed, setVoiceInputUsed] = useState(false);
  const { isAuthenticated } = useAuth();
  
  // Check if voice features are supported
  const { isVoiceEnabled } = useVoiceCapability();
  
  // Speech synthesis
  const { isSpeaking, speakText, stopSpeaking } = useTextToSpeech(isAuthenticated);
  
  // Speech recognition
  const { isListening, transcript, startListening, stopListening, setOnTranscriptReady } = useSpeechRecognition(isAuthenticated);
  
  // Mark when voice input was used to auto-play next response
  const onStartListening = () => {
    console.log('Voice input started - marking for auto-speak');
    setVoiceInputUsed(true);
    startListening();
  };
  
  // When transcript is sent, we keep the flag active
  // It will be reset after the next AI response is spoken
  const handleTranscriptSent = () => {
    console.log('Transcript sent - voiceInputUsed flag is:', voiceInputUsed);
    // Note: We're no longer resetting the flag here
    // This ensures the next response will be spoken
  };
  
  return {
    // State
    isAuthenticated,
    isVoiceEnabled,
    isListening,
    isSpeaking,
    shouldAutoSpeak,
    transcript,
    voiceInputUsed,
    
    // Setters
    setShouldAutoSpeak,
    setOnTranscriptReady,
    setVoiceInputUsed,
    
    // Functions
    startListening: onStartListening,
    stopListening,
    speakText,
    stopSpeaking,
    handleTranscriptSent
  };
}
